import type { HTMLAttributes, ReactNode } from 'react';
import { joinCss } from '@/shared/lib/css-utils';
import css from './input-group.module.scss';

type InputGroupProps = HTMLAttributes<HTMLDivElement> & {
  label: string;
  htmlFor?: string;
  children: ReactNode;
  error?: string;
};

export const InputGroup = ({
  label,
  htmlFor,
  children,
  error,
  className,
  ...restProps
}: InputGroupProps) => (
  <div
    className={joinCss(css.root, error && css.hasError, className)}
    {...restProps}
  >
    <label className={css.label} htmlFor={htmlFor}>
      {label}
    </label>
    {children}
    {error && <span className={css.error}>{error}</span>}
  </div>
);
